import {ITechnicalApplicationEditModel} from './i-technical-application-edit-model';

export class UpdateTechnicalApplicationModel implements ITechnicalApplicationEditModel {
  executorId:	string;
  name:	string;
  categoryId:	string;
  minSize: number;
  maxSize:	number;
  iconURL:	string;
  defaultRatio:	string;
  foilCount:	number;
  wet:	string;
  virginHair:	string;
  state:	string;
  calc: string;
}
